import { createSlice } from "@reduxjs/toolkit";
import Assessment from "../../assets/icons/assessments";
import Games from "../../assets/icons/games";
import MarketingPages from "../../assets/icons/marketingPages";
import Themes from "../../assets/icons/themes";
import Video from "../../assets/icons/video";

const initialState = {
  categories: [
  
  ],
  selectedCategoryName: '',
  videoActivityActive: false,
  videoModalActive: false,
  categoryDropdownActive: false,
};

const activityCategories = createSlice({
  name: "activityCategories",
  initialState,
  reducers: {
    updateCategories: (state, { payload }) => {
      state.categories = payload;
    },
    showVideoModalActive: (state, { payload }) => {
      state.videoModalActive = true;
    },
    closeVideoModalActive: (state, { payload }) => {
      state.videoModalActive = false;
    },
    toggleCategoryDropdown: (state, { payload }) => {
      state.categoryDropdownActive = payload.active;
    },
    closeCategoryDropdown: (state, { payload }) => {
      state.categoryDropdownActive = false;
    },
    toggleVideoActivity: (state, { payload }) => {
      state.videoActivityActive = !state.videoActivityActive;
    },
    updateSelectedCategory: (state, { payload }) => {
      state.selectedCategoryName = payload.name
    },
    selectCategory: (state, { payload }) => {
      return {
        ...state,
        categories: state.categories.map((category) => (category.id === payload.id ? { ...category, isSelected: true } : category.isSelected === true ? { ...category, isSelected: false } : category)),
      };
    },
    selectSingleCategory: (state, { payload }) => {
      return {
        ...state,
        categories: state.categories.map(category => (category.id === payload.id ? { ...category, isSelected: true } : { ...category, isSelected: false })),
      };
    },
    openCategory: (state, { payload }) => {
      return {
        ...state,
        categories: state.categories.map((category) => (category.id === payload.id ? { ...category, isOpened: true } : category.isOpened === true ? { ...category, isOpened: false } : category)),
      };
    },
  },
});

export const { updateCategories, selectCategory, selectSingleCategory, openCategory,
   toggleCategoryDropdown, showVideoModalActive, closeVideoModalActive, toggleVideoActivity, closeCategoryDropdown, updateSelectedCategory } =
  activityCategories.actions;
export default activityCategories.reducer;
